import React from 'react';
const DButton = (props) => {

    return (
        <>
            {
                props && props.clickHandler != null &&
                <button className="relative my-4 py-2 lg:px-8 px-6 text-white rounded-full flex items-center bg-dinshaw-theme text-sm lg:text-lg" onClick={() => props.clickHandler(props.inputProps)}>
                    {/* <span className="absolute right-0 flex items-center justify-start w-6 h-6 duration-300 transform translate-x-full group-hover:translate-x-0 ease-linear ">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
            </span> */}
                    <span className="relative">{props.children}</span>
                </button>
            }
        </>
    );
}

export default DButton;